/**
 * Marca com `data-rolando` o elemento que está rolando, e tira a marca
 * quando ele para. A barra de rolagem só aparece com a marca
 * (`ui/style/layout/scrollbar.css`). Um listener só, na captura do
 * documento: `scroll` não sobe, mas desce pela captura, então pega todo
 * contêiner da página, inclusive os que montam depois.
 */

/** Quanto a barra fica depois do último movimento. */
export const PARADA_MS = 900

export function instalarRolagem(doc: Document = document): () => void {
  const timers = new WeakMap<Element, ReturnType<typeof setTimeout>>()

  const aoRolar = (evento: Event) => {
    // A página que rola manda o evento pelo documento, não pelo elemento.
    const alvo =
      evento.target instanceof Element
        ? evento.target
        : (doc.scrollingElement ?? doc.documentElement)
    alvo.setAttribute('data-rolando', '')
    const anterior = timers.get(alvo)
    if (anterior !== undefined) clearTimeout(anterior)
    timers.set(
      alvo,
      setTimeout(() => {
        alvo.removeAttribute('data-rolando')
        timers.delete(alvo)
      }, PARADA_MS),
    )
  }

  doc.addEventListener('scroll', aoRolar, { capture: true, passive: true })
  return () => doc.removeEventListener('scroll', aoRolar, { capture: true })
}
